export default __webpack_public_path__ + "assets/images/d97d278d19cfe39350b2e6884ca05378.jpg";